import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import { keyframes } from '@mui/system';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.5; }
`;

interface LoadingScreenProps {
  minHeight?: string;
  message?: string;
}

export default function LoadingScreen({ minHeight = '80vh', message = 'Loading...' }: LoadingScreenProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight,
        gap: 3,
        animation: `${fadeIn} 0.4s ease-out`,
      }}
    >
      <Box
        component="img"
        src="/wz-icon-blue.png"
        alt="Wicklander-Zulawski"
        sx={{
          height: 48,
          width: 48,
          objectFit: 'contain',
          animation: `${pulse} 2s ease-in-out infinite`,
        }}
      />

      <Box sx={{ textAlign: 'center', width: 200 }}>
        <Typography
          sx={{
            fontSize: 13,
            fontWeight: 500,
            color: 'text.secondary',
            letterSpacing: '0.02em',
            mb: 1.5,
          }}
        >
          {message}
        </Typography>
        <LinearProgress
          sx={{
            height: 3,
            borderRadius: 2,
            backgroundColor: '#F2F2F3',
            '& .MuiLinearProgress-bar': {
              borderRadius: 2,
              backgroundColor: 'primary.main',
            },
          }}
        />
      </Box>
    </Box>
  );
}
